import { configureStore } from "@reduxjs/toolkit";

import rootReducer from "./reducers";
import { tokenMiddleware } from "../middlewares/tokenMiddleware";
import { initializeAuth } from "./actions/auth_action";

const createAppStore = async () => {
  try {
    const store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
          tokenMiddleware
        ),
    });

    try {
      await store.dispatch(initializeAuth());
    } catch (e) {
      console.warn("initializeAuth failed:", e);
    }

    return store;
  } catch (error) {
    throw new Error(error?.message || "Failed to create store");
  }
};

export default createAppStore;
